import { render } from "./ReviewCreate.vue?vue&type=template&id=01b17b46"
import script from "./ReviewCreate.vue?vue&type=script&lang=js"
export * from "./ReviewCreate.vue?vue&type=script&lang=js"

import "./ReviewCreate.vue?vue&type=style&index=0&id=01b17b46&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__